import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-audit-trail',
  templateUrl: './audit-trail.component.html',
  styleUrls: ['./audit-trail.component.css']
})
export class AuditTrailComponent {

  externalApplication = false;

  constructor(private route: ActivatedRoute) { 
    this.route.queryParams.subscribe(params => {
      this.externalApplication = (params['ex'] === 'true');
    });
   }
}
